/* Quadrajet Power — Vehicle fitment & My Garage
 *
 * Products are matched to vehicles through Shopify tags using this convention:
 *   year_1969   make_chevrolet
 *
 * A product with NO fitment tags is treated as universal and always shows.
 * "Find My Quadrajet" uses Shopify's native tag filtering inside the matching
 * Shop by Make collection:
 * /collections/chevrolet-quadrajets/year_1969+make_chevrolet
 *
 * EDIT THE VEHICLE LIST BELOW to control the dropdown choices.
 */
(function () {
  'use strict';

  var FITMENT = {
    years: { from: 1965, to: 1990 },
    makes: {
      'Chevrolet': ['262', '265', '267', '283', '305', '307', '327', '350', '400', '402', '427', '454'],
      'Pontiac': ['265', '301', '326', '350', '389', '400', '421', '428', '455', 'Firebird', 'GTO', 'Grand Prix', 'Trans Am'],
      'Oldsmobile': ['260', '307', '330', '350', '400', '403', '425', '455', 'Cutlass', '442', 'Toronado'],
      'Buick': ['301', '307', '350', '400', '430', '455', 'GS', 'Riviera', 'Skylark'],
      'Cadillac': ['307', '368', '425', '472', '500', 'DeVille', 'Eldorado', 'Fleetwood'],
      'GMC': ['305', '307', '350', '400', '454', 'Jimmy', 'Sierra', 'Suburban'],
      'Marine': ['Mercruiser', 'OMC', 'Volvo Penta', 'Crusader', 'Chris-Craft']
    }
  };

  var KEY = 'qjp_garage_v1';
  var MAKE_COLLECTIONS = {
    'Buick': 'buick-quadrajets',
    'Cadillac': 'cadillac-quadrajets',
    'Chevrolet': 'chevrolet-quadrajets',
    'GMC': 'chevrolet-quadrajets',
    'Oldsmobile': 'oldsmobile-quadrajets',
    'Pontiac': 'pontiac-quadrajets',
    'Marine': 'other-quadrajets'
  };
  // Populated inside the fitment-bar block so the cross-tab listener can call
  // it without caring whether a bar is present on this page.
  var prefillFitmentBar = function () {};
  var handle = function (s) {
    return String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };

  function validVehicle(v) {
    if (!v || typeof v !== 'object') return false;
    var y = parseInt(v.year, 10);
    if (isNaN(y) || y < FITMENT.years.from || y > FITMENT.years.to) return false;
    if (!Object.prototype.hasOwnProperty.call(FITMENT.makes, v.make)) return false;
    return true;
  }
  function normalizeVehicles(vehicles) {
    var seen = {};
    return vehicles.filter(validVehicle).map(function (v) {
      return { year: String(v.year), make: v.make, model: '' };
    }).filter(function (v) {
      var key = v.year + '|' + v.make;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }
  function load() {
    try {
      var g = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (!Array.isArray(g.vehicles)) return { vehicles: [], active: -1 };
      var act = g.active >= 0 && g.vehicles[g.active] ? g.vehicles[g.active] : null;
      g.vehicles = normalizeVehicles(g.vehicles);
      g.active = act && validVehicle(act) ? g.vehicles.findIndex(function (x) { return vehicleName(x) === vehicleName(act); }) : (g.vehicles.length ? 0 : -1);
      if (g.active === -1 && g.vehicles.length) g.active = 0;
      if (!g.vehicles.length) g.active = -1;
      return g;
    } catch (e) { return { vehicles: [], active: -1 }; }
  }
  function save(g) {
    try { localStorage.setItem(KEY, JSON.stringify(g)); } catch (e) {}
    // Notify same-tab listeners (storage events don't fire in the originating tab).
    window.dispatchEvent(new CustomEvent('qjp:garage-changed'));
  }

  /* ---------- Cross-device hydration for logged-in customers ----------
   * localStorage is per-browser, so saved vehicles vanish in private windows
   * or after clearing browser data. theme.liquid outputs the logged-in
   * customer's `qjp.garage` metafield (when present) as window.QJPCustomer;
   * we hydrate local state from it on page load. Writing the metafield
   * requires a server with Shopify Admin API access — see the sync backend
   * (pending) — theme JS alone cannot write customer metafields.
   */
  var remote = window.QJPCustomer || { loggedIn: false, garage: null };

  function parseRemoteGarage(raw) {
    var data = raw;
    if (typeof data === 'string') {
      try { data = JSON.parse(data); } catch (e) { return null; }
    }
    if (!data || !Array.isArray(data.vehicles)) return null;
    var vehicles = normalizeVehicles(data.vehicles);
    if (!vehicles.length) return null;
    var active = typeof data.active === 'number' && vehicles[data.active] ? data.active : 0;
    return { vehicles: vehicles, active: active };
  }

  // Hydrate before first render: merge the server-side garage into local state.
  (function hydrateFromRemote() {
    if (!remote.loggedIn) return;
    var server = parseRemoteGarage(remote.garage);
    if (!server) return;
    var local = load();
    if (!local.vehicles.length) {
      // Fresh browser / private window: adopt the server garage wholesale.
      try { localStorage.setItem(KEY, JSON.stringify(server)); } catch (e) {}
      return;
    }
    // Merge: union of vehicles, local active selection wins.
    var names = local.vehicles.map(vehicleName);
    server.vehicles.forEach(function (v) {
      if (names.indexOf(vehicleName(v)) === -1) local.vehicles.push(v);
    });
    try { localStorage.setItem(KEY, JSON.stringify(local)); } catch (e) {}
  })();
  function activeVehicle(g) { return g.active >= 0 && g.vehicles[g.active] ? g.vehicles[g.active] : null; }
  function vehicleName(v) { return [v.year, v.make].filter(Boolean).join(' '); }
  function vehicleTags(v) {
    var t = [];
    if (v.year) t.push('year_' + handle(v.year));
    if (v.make) t.push('make_' + handle(v.make));
    return t;
  }
  function collectionUrl(v) {
    var collection = MAKE_COLLECTIONS[v.make] || 'other-quadrajets';
    return '/collections/' + collection + '/' + vehicleTags(v).join('+');
  }

  /* ---------- Fitment bar ---------- */
  var bar = document.querySelector('[data-fitment-bar]');
  if (bar) {
    var purposeSel = bar.querySelector('[data-fit-purpose]');
    var vehicleFields = bar.querySelector('[data-fit-vehicle-fields]');
    var coreCallout = bar.querySelector('[data-fit-core-callout]');
    var codeFocusTimer = null;
    var yearSel = bar.querySelector('[data-fit-year]');
    var makeSel = bar.querySelector('[data-fit-make]');
    var statusEl = bar.querySelector('[data-fit-status]');

    function showVehicleFields(show) {
      if (vehicleFields) vehicleFields.hidden = !show;
      if (coreCallout) coreCallout.hidden = !show;
    }

    function openCodeFinder() {
      var finder = document.getElementById('find-code');
      if (!finder) {
        window.location.href = bar.getAttribute('data-code-finder-url') || '/#find-code';
        return;
      }
      finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
      finder.classList.add('code-finder--highlight');
      setTimeout(function () { finder.classList.remove('code-finder--highlight'); }, 1800);
      var input = finder.querySelector('input[name="q"]');
      if (input) {
        codeFocusTimer = setTimeout(function () {
          codeFocusTimer = null;
          if (!purposeSel || purposeSel.value === 'kits-parts') input.focus();
        }, 350);
      }
      setStatus('Enter the stamped carburetor code to find exact kits and parts.', 'ok');
    }

    if (purposeSel) {
      showVehicleFields(purposeSel.value === 'carburetor');
      purposeSel.addEventListener('change', function () {
        if (codeFocusTimer) {
          clearTimeout(codeFocusTimer);
          codeFocusTimer = null;
        }
        bar.classList.remove('fitment-bar--error');
        setStatus('');
        if (purposeSel.value === 'kits-parts') {
          showVehicleFields(false);
          openCodeFinder();
          return;
        }
        var show = purposeSel.value === 'carburetor';
        showVehicleFields(show);
        if (show) yearSel.focus();
      });
    } else {
      showVehicleFields(true);
    }

    for (var y = FITMENT.years.to; y >= FITMENT.years.from; y--) {
      yearSel.add(new Option(y, y));
    }

    function setStatus(text, tone) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      statusEl.hidden = !text;
      statusEl.classList.toggle('fitment-bar__status--ok', tone === 'ok');
    }

    yearSel.addEventListener('change', function () {
      makeSel.length = 1;
      if (yearSel.value) {
        Object.keys(FITMENT.makes).forEach(function (m) { makeSel.add(new Option(m, m)); });
      }
      makeSel.disabled = !yearSel.value;
    });

    function currentSelection() {
      if (!yearSel.value || !makeSel.value) return null;
      return { year: yearSel.value, make: makeSel.value, model: '' };
    }

    // Prefill the bar from the collection URL's fitment tags (after Find Parts
    // navigates), falling back to the active garage vehicle, so the selection
    // survives the page reload and Save to Garage works right away.
    function prefill(force) {
      // After an explicit Reset, keep the bar empty while browsing until the
      // shopper picks a vehicle again (from the dropdowns or the Garage).
      try {
        if (sessionStorage.getItem('qjp_fit_reset')) {
          if (!force) return;
          sessionStorage.removeItem('qjp_fit_reset');
        }
      } catch (e) {}
      var v = null;
      var m = window.location.pathname.match(/\/collections\/[^\/]+\/([^\/?]+)/);
      if (m) {
        var sel = {};
        decodeURIComponent(m[1]).split(/[+ ]/).forEach(function (t) {
          var parts = t.split('_');
          if (parts.length > 1) sel[parts[0]] = parts.slice(1).join('_');
        });
        if (sel.year && sel.make) {
          var makeKey = Object.keys(FITMENT.makes).filter(function (k) { return handle(k) === sel.make; })[0];
          if (makeKey) v = { year: sel.year, make: makeKey, model: '' };
        }
      }
      // Prefer the selection stashed when Find Carbs was clicked if Shopify
      // redirects a tag-filtered collection URL.
      try {
        var stored = JSON.parse(sessionStorage.getItem('qjp_fit_sel') || 'null');
        if (stored && stored.year && stored.make) {
          if (!v) {
            if (m) v = { year: String(stored.year), make: stored.make, model: '' };
          } else if (String(stored.year) === String(v.year) && handle(stored.make) === handle(v.make)) {
            v = { year: String(stored.year), make: stored.make, model: '' };
          }
        }
      } catch (e) { /* ignore bad JSON */ }
      if (!v) v = activeVehicle(load());
      if (!v || !validVehicle(v)) return;
      if (purposeSel) purposeSel.value = 'carburetor';
      showVehicleFields(true);
      yearSel.value = String(v.year);
      if (yearSel.value !== String(v.year)) return;
      yearSel.dispatchEvent(new Event('change'));
      makeSel.value = v.make;
      makeSel.dispatchEvent(new Event('change'));
      setStatus('');
    }
    prefillFitmentBar = prefill;
    prefill();

    bar.querySelector('[data-fit-go]').addEventListener('click', function () {
      var v = currentSelection();
      if (!v) {
        bar.classList.add('fitment-bar--error');
        setStatus('Choose A Carburetor, then select Year and Make.');
        return;
      }
      setStatus('Finding available Quadrajets for your ' + vehicleName(v) + '\u2026', 'ok');
      // Stash the selection so prefill() can recover it after navigation.
      try { sessionStorage.setItem('qjp_fit_sel', JSON.stringify(v)); } catch (e) {}
      // Brief pause so the confirmation is visible before the results load.
      setTimeout(function () { window.location.href = collectionUrl(v); }, 400);
    });

    bar.querySelector('[data-fit-save]').addEventListener('click', function () {
      var v = currentSelection();
      if (!v) {
        bar.classList.add('fitment-bar--error');
        setStatus('Choose A Carburetor, then select Year and Make to save a vehicle.');
        return;
      }
      var g = load();
      var name = vehicleName(v);
      var idx = g.vehicles.findIndex(function (x) { return vehicleName(x) === name; });
      if (idx !== -1 && g.active === idx) {
        setStatus(name + ' is already in your Garage.', 'ok');
        return;
      }
      if (idx === -1) { g.vehicles.push(v); idx = g.vehicles.length - 1; }
      g.active = idx;
      sessionStorage.removeItem('qjp_show_all');
      sessionStorage.removeItem('qjp_nudge_dismissed');
      save(g);
      renderGarage();
      applyVehicleFilter();
      setStatus('Saved ' + name + ' to your Garage.', 'ok');
    });

    var resetBtn = bar.querySelector('[data-fit-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        yearSel.value = '';
        yearSel.dispatchEvent(new Event('change'));
        bar.classList.remove('fitment-bar--error');
        setStatus('');
        try {
          sessionStorage.removeItem('qjp_fit_sel');
          sessionStorage.setItem('qjp_fit_reset', '1');
        } catch (e) {}
        // If we're on a vehicle-filtered collection page, go back to the
        // unfiltered collection so "Reset" also clears the results.
        var m = window.location.pathname.match(/^(\/collections\/[^\/]+)\/[^\/?]+/);
        if (m) { window.location.href = m[1]; return; }
        // Otherwise re-show the full product list (client-side vehicle
        // filtering may be hiding non-fitting products on this page).
        sessionStorage.setItem('qjp_show_all', '1');
        applyVehicleFilter();
      });
    }

    [yearSel, makeSel].forEach(function (s) {
      s.addEventListener('change', function () {
        bar.classList.remove('fitment-bar--error');
        setStatus('');
        // Picking a vehicle again ends the "stay empty after Reset" state.
        if (yearSel.value) { try { sessionStorage.removeItem('qjp_fit_reset'); } catch (e) {} }
      });
    });
  }

  /* ---------- Garage header widget ---------- */
  var garageToggle = document.querySelector('[data-garage-toggle]');
  var garagePanel = document.querySelector('[data-garage-panel]');

  function renderGarage() {
    var g = load();
    var count = document.querySelector('[data-garage-count]');
    if (count) {
      count.textContent = g.vehicles.length;
      count.hidden = g.vehicles.length === 0;
    }
    if (!garagePanel) return;
    var list = garagePanel.querySelector('[data-garage-list]');
    var empty = garagePanel.querySelector('[data-garage-empty]');
    list.innerHTML = '';
    empty.hidden = g.vehicles.length > 0;
    g.vehicles.forEach(function (v, i) {
      var row = document.createElement('div');
      row.className = 'garage-row' + (i === g.active ? ' garage-row--active' : '');
      var name = document.createElement('button');
      name.type = 'button';
      name.className = 'garage-row__name';
      name.textContent = vehicleName(v);
      name.title = 'Make this my active vehicle';
      name.addEventListener('click', function () { g.active = i; sessionStorage.removeItem('qjp_show_all'); save(g); renderGarage(); applyVehicleFilter(); prefillFitmentBar(true); });
      var shop = document.createElement('a');
      shop.className = 'garage-row__shop';
      shop.href = collectionUrl(v);
      shop.textContent = 'Shop carbs';
      var del = document.createElement('button');
      del.type = 'button';
      del.className = 'garage-row__remove';
      del.setAttribute('aria-label', 'Remove ' + vehicleName(v));
      del.textContent = '\u00d7';
      del.addEventListener('click', function () {
        g.vehicles.splice(i, 1);
        if (g.active === i) g.active = g.vehicles.length ? 0 : -1;
        else if (g.active > i) g.active--;
        sessionStorage.removeItem('qjp_show_all');
        save(g); renderGarage(); applyVehicleFilter(); prefillFitmentBar(true);
      });
      row.appendChild(name); row.appendChild(shop); row.appendChild(del);
      list.appendChild(row);
    });
  }

  if (garageToggle && garagePanel) {
    garageToggle.addEventListener('click', function (e) {
      e.preventDefault();
      var open = !garagePanel.hidden;
      garagePanel.hidden = open;
      garageToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
    document.addEventListener('click', function (e) {
      if (!garagePanel.hidden && !garagePanel.contains(e.target) && !garageToggle.contains(e.target)) {
        garagePanel.hidden = true;
        garageToggle.setAttribute('aria-expanded', 'false');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !garagePanel.hidden) {
        garagePanel.hidden = true;
        garageToggle.setAttribute('aria-expanded', 'false');
        garageToggle.focus();
      }
    });
  }

  /* ---------- Vehicle-aware results (collection & search grids) ---------- */
  function isCarbSearchCollection() {
    return /^\/collections\/(buick|cadillac|chevrolet|oldsmobile|pontiac|other)-quadrajets(?:\/|$)/.test(window.location.pathname);
  }

  function applyVehicleFilter() {
    renderProductFitment();
    renderCartFitment();
    renderCartVehiclePrompt();
    // Saved vehicles should not filter parts, kits, homepage strips, or search
    // results. Vehicle filtering is exclusively for Shop by Make carb listings.
    if (!isCarbSearchCollection()) return;
    var grids = document.querySelectorAll('.products-grid');
    if (!grids.length) return;
    var g = load();
    var v = activeVehicle(g);
    var urlFiltered = isCarbSearchCollection() && /\/collections\/[^/]+\/.*(year_|make_)/.test(window.location.pathname);
    var banner = document.querySelector('[data-fitment-banner]');
    if (banner) banner.remove();

    var showAll = sessionStorage.getItem('qjp_show_all') === '1';

    grids.forEach(function (grid) {
      grid.querySelectorAll('[data-fitment-tags]').forEach(function (card) {
        card.hidden = false;
      });
    });

    if (urlFiltered) return;

    if (!v) {
      // Show a nudge banner when the page has fitment-tagged products but no vehicle is saved.
      // Guard is checked first so navigation to a new collection page never re-shows a dismissed nudge,
      // regardless of when applyVehicleFilter() is called during page load.
      if (!bar || sessionStorage.getItem('qjp_nudge_dismissed') === '1') return;
      var hasFitmentProducts = false;
      grids.forEach(function (grid) {
        grid.querySelectorAll('[data-fitment-tags]').forEach(function (card) {
          if ((card.getAttribute('data-fitment-tags') || '').split(/\s+/).filter(Boolean).length) {
            hasFitmentProducts = true;
          }
        });
      });
      if (hasFitmentProducts) {
        var nudge = document.createElement('div');
        nudge.className = 'fitment-nudge';
        nudge.setAttribute('data-fitment-banner', '');
        var nudgeText = document.createElement('span');
        nudgeText.className = 'fitment-nudge__text';
        nudgeText.textContent = 'These build-to-order Quadrajets are application-specific. Select a year and make to see matching carburetors.';
        var nudgeLink = document.createElement('a');
        nudgeLink.href = '#';
        nudgeLink.className = 'fitment-nudge__link';
        nudgeLink.textContent = 'Pick your vehicle \u2192';
        nudgeLink.addEventListener('click', function (e) {
          e.preventDefault();
          bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
          bar.classList.add('fitment-bar--highlight');
          setTimeout(function () { bar.classList.remove('fitment-bar--highlight'); }, 2000);
          var ySel = bar.querySelector('[data-fit-year]');
          if (ySel) ySel.focus({ preventScroll: true });
        });
        var nudgeDismiss = document.createElement('button');
        nudgeDismiss.type = 'button';
        nudgeDismiss.className = 'fitment-nudge__dismiss';
        nudgeDismiss.setAttribute('aria-label', 'Dismiss vehicle prompt');
        nudgeDismiss.textContent = '\u00d7';
        nudgeDismiss.addEventListener('click', function () {
          sessionStorage.setItem('qjp_nudge_dismissed', '1');
          nudge.remove();
        });
        nudge.appendChild(nudgeText);
        nudge.appendChild(nudgeLink);
        nudge.appendChild(nudgeDismiss);
        grids[0].parentNode.insertBefore(nudge, grids[0]);
      }
      return;
    }

    var tags = vehicleTags(v);
    var hiddenCount = 0;
    if (!showAll) {
      grids.forEach(function (grid) {
        grid.querySelectorAll('[data-fitment-tags]').forEach(function (card) {
          var cardTags = (card.getAttribute('data-fitment-tags') || '').split(/\s+/).filter(Boolean);
          var declares = { year: false, make: false };
          cardTags.forEach(function (t) {
            if (t.indexOf('year_') === 0) declares.year = true;
            if (t.indexOf('make_') === 0) declares.make = true;
          });
          // Universal products (no year/make tags) always show.
          if (!declares.year && !declares.make) return;
          // A product must match every dimension it declares. If it declares a
          // dimension the vehicle doesn't specify (e.g. model), it is hidden —
          // we can't confirm fitment, and "Show all parts" is one click away.
          var selected = { year: false, make: false };
          tags.forEach(function (t) { selected[t.split('_')[0]] = true; });
          var ok = ['year', 'make'].every(function (dim) {
            if (!declares[dim]) return true; // product doesn't restrict this dimension
            if (!selected[dim]) return false; // product restricts it but vehicle doesn't specify it
            var want = tags.filter(function (t) { return t.indexOf(dim + '_') === 0; })[0];
            return cardTags.indexOf(want) !== -1;
          });
          if (!ok) { card.hidden = true; hiddenCount++; }
        });
      });
    }

    var firstGrid = grids[0];
    var b = document.createElement('div');
    b.className = 'fitment-banner';
    b.setAttribute('data-fitment-banner', '');
    var msg = document.createElement('span');
    var strong = document.createElement('strong');
    if (showAll) {
      strong.textContent = 'all available Quadrajets';
      msg.appendChild(document.createTextNode('Showing '));
      msg.appendChild(strong);
      msg.appendChild(document.createTextNode('. Your garage vehicle: ' + vehicleName(v)));
    } else {
      strong.textContent = vehicleName(v);
      msg.appendChild(document.createTextNode('Showing available Quadrajets for your '));
      msg.appendChild(strong);
      if (hiddenCount) msg.appendChild(document.createTextNode(' (' + hiddenCount + ' hidden)'));
    }
    var toggleBtn = document.createElement('button');
    toggleBtn.type = 'button';
    toggleBtn.className = 'fitment-banner__toggle';
    toggleBtn.textContent = showAll ? 'Filter to my vehicle' : 'Show all available Quadrajets';
    toggleBtn.addEventListener('click', function () {
      sessionStorage.setItem('qjp_show_all', showAll ? '0' : '1');
      applyVehicleFilter();
    });
    b.appendChild(msg); b.appendChild(toggleBtn);
    firstGrid.parentNode.insertBefore(b, firstGrid);
  }

  /* ---------- Product page fitment badge ---------- */
  function tagsMatchVehicle(cardTags, v) {
    var declares = { year: false, make: false };
    cardTags.forEach(function (t) {
      if (t.indexOf('year_') === 0) declares.year = true;
      if (t.indexOf('make_') === 0) declares.make = true;
    });
    if (!declares.year && !declares.make) return 'universal';
    var tags = vehicleTags(v);
    var selected = { year: false, make: false };
    tags.forEach(function (t) { selected[t.split('_')[0]] = true; });
    var ok = ['year', 'make'].every(function (dim) {
      if (!declares[dim]) return true;
      if (!selected[dim]) return false;
      var want = tags.filter(function (t) { return t.indexOf(dim + '_') === 0; })[0];
      return cardTags.indexOf(want) !== -1;
    });
    return ok ? 'fit' : 'nofit';
  }

  function renderProductFitment() {
    var badge = document.querySelector('[data-product-fitment]');
    if (!badge) return;
    var textEl = badge.querySelector('[data-fitment-text]');
    var linkEl = badge.querySelector('[data-fitment-link]');
    var cardTags = (badge.getAttribute('data-fitment-tags') || '').split(/\s+/).filter(Boolean);
    var v = activeVehicle(load());
    badge.classList.remove('product-fitment--ok', 'product-fitment--no', 'product-fitment--universal', 'product-fitment--select');
    linkEl.hidden = true;
    if (!cardTags.length) {
      badge.classList.add('product-fitment--universal');
      textEl.textContent = 'Universal fit \u2014 works with any application.';
      badge.hidden = false;
      return;
    }
    if (!v) {
      badge.classList.add('product-fitment--select');
      textEl.textContent = 'Check if this fits your vehicle.';
      if (bar) {
        linkEl.textContent = 'Select your vehicle';
        linkEl.href = '#';
        linkEl.hidden = false;
        if (!linkEl.hasAttribute('data-select-bound')) {
          linkEl.setAttribute('data-select-bound', '');
          linkEl.addEventListener('click', function (e) {
            if (badge.classList.contains('product-fitment--select')) {
              e.preventDefault();
              bar.scrollIntoView({ behavior: 'smooth', block: 'center' });
              bar.classList.add('fitment-bar--highlight');
              setTimeout(function () { bar.classList.remove('fitment-bar--highlight'); }, 2000);
              var yearSel = bar.querySelector('[data-fit-year]');
              if (yearSel) yearSel.focus({ preventScroll: true });
            }
          });
        }
      }
      badge.hidden = false;
      return;
    }
    var result = tagsMatchVehicle(cardTags, v);
    if (result === 'fit') {
      badge.classList.add('product-fitment--ok');
      textEl.textContent = 'Fits your ' + vehicleName(v);
    } else {
      badge.classList.add('product-fitment--no');
      textEl.textContent = 'May not fit your ' + vehicleName(v) + '.';
      linkEl.textContent = 'Shop available Quadrajets for your ' + vehicleName(v);
      linkEl.href = collectionUrl(v);
      linkEl.hidden = false;
    }
    badge.hidden = false;
  }

  /* ---------- Cart page vehicle prompt ---------- */
  function renderCartVehiclePrompt() {
    var prompt = document.getElementById('cart-vehicle-prompt');
    if (!prompt) return;
    var hasVehicle = !!activeVehicle(load());
    prompt.hidden = hasVehicle;

    // Wire up the link once — scroll to fitment bar if present on the page
    var link = document.getElementById('cart-vehicle-prompt-link');
    if (link && !link.hasAttribute('data-prompt-bound')) {
      link.setAttribute('data-prompt-bound', '');
      var fitBar = document.querySelector('[data-fitment-bar]');
      if (fitBar) {
        link.href = '#';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          fitBar.scrollIntoView({ behavior: 'smooth', block: 'center' });
          fitBar.classList.add('fitment-bar--highlight');
          setTimeout(function () { fitBar.classList.remove('fitment-bar--highlight'); }, 2000);
          var yearSel = fitBar.querySelector('[data-fit-year]');
          if (yearSel) yearSel.focus({ preventScroll: true });
        });
      }
    }
  }

  /* ---------- Cart line-item fitment warnings ---------- */
  function renderCartFitment() {
    var rows = document.querySelectorAll('[data-cart-fitment-tags]');
    if (!rows.length) return;
    var v = activeVehicle(load());
    rows.forEach(function (row) {
      var warn = row.querySelector('[data-cart-fitment-warning]');
      if (!warn) return;
      warn.hidden = true;
      warn.textContent = '';
      if (!v) return;
      var cardTags = (row.getAttribute('data-cart-fitment-tags') || '').split(/\s+/).filter(Boolean);
      if (!cardTags.length) return; // universal product
      if (tagsMatchVehicle(cardTags, v) === 'nofit') {
        warn.appendChild(document.createTextNode('\u26a0 May not fit your ' + vehicleName(v) + '. Double-check before checkout. '));
        var link = document.createElement('a');
        link.className = 'product-fitment__link cart-fitment-warning__link';
        link.href = collectionUrl(v);
        link.textContent = 'Shop available Quadrajets for your ' + vehicleName(v);
        warn.appendChild(link);
        var line = row.getAttribute('data-cart-line');
        if (line) {
          var removeLink = document.createElement('a');
          removeLink.className = 'product-fitment__link cart-fitment-warning__link cart-fitment-warning__remove';
          removeLink.href = '/cart/change?line=' + encodeURIComponent(line) + '&quantity=0';
          removeLink.textContent = 'Remove this item';
          warn.appendChild(removeLink);
        }
        warn.hidden = false;
      }
    });
  }

  renderGarage();
  applyVehicleFilter();

  /* re-run fitment badges/banner/grid filter after instant navigation swaps
     in a new collection page without a full reload */
  window.addEventListener('qjp:page-swapped', function () {
    prefillFitmentBar();
    applyVehicleFilter();
  });

  /* ---------- Cross-tab sync ----------
   * The browser fires 'storage' in every tab *except* the one that wrote the
   * value, so this keeps the cart page (and any other open tab) in sync when
   * a vehicle is saved or removed from a different tab.
   */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    renderGarage();           // garage badge count
    prefillFitmentBar(true);      // resets fitment-bar dropdowns to the new active vehicle
    applyVehicleFilter();     // collection-page banner + grid, renderProductFitment, renderCartFitment, renderCartVehiclePrompt
  });
})();
